exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-layout.scroll-bar,.column-layout.scroll-bar .left-column>div{height:100%}.column-layout.scroll-bar .el-tree.el-tree--highlight-current{height:calc(100% - 57px);height:-moz-calc(100% - 57px);overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-523db9c8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/retailer/GoodsCategAndBrandSelect.vue
// module id = 3101
// module chunks = 0